<template>
  <b-tabs
      content-class="mt-3"
      fill
      @activate-tab="handleActivateTab"
  >
    <b-tab title="Chat" active>
      <body-chat
          :profile="profile"
          :message-box-ref-id="messageBoxRefId"
          :comm-with="commWith"
          :heartbeats="heartbeats"
          :messages="messages"
          :selected-heart-beat="selectedHeartBeat"
      />
    </b-tab>
    <b-tab title="Video">
      <body-video
          :profile="profile"
          :message-box-ref-id="messageBoxRefId"
          :comm-with="commWith"
          :heartbeats="heartbeats"
          :messages="messages"
          :selected-heart-beat="selectedHeartBeat"
      />
    </b-tab>
    <b-tab title="Audio" disabled>
    </b-tab>
  </b-tabs>
</template>
<script>

import BodyChat from "./chat";
import BodyVideo from "./video";
export default {
  name: "Chat_SideBar_Body",
  components: {
    BodyChat,
    BodyVideo
  },
  props: {
    profile: {
      type: Object,
      default: null,
      required: false
    },
    messageBoxRefId: {
      type: String,
      required: true
    },
    commWith: {
      type: String,
      required: true
    },
    heartbeats: {
      type: Array,
      default: ()=>{ return []},
      required: false
    },
    messages: {
      type: Array,
      default: ()=>{return []},
      required: false
    },
    selectedHeartBeat: {
      type: Object,
      default: null,
      required: false
    },
  },
  created() {

  },
  mounted() {},
  computed: {},
  methods: {
    handleActivateTab(tabIdx) {
      debugger;
      this.$emit(`activate-tab`,tabIdx);
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped></style>
